import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorEspIntl } from './mat-paginator-esp.intl';

export const MatPaginatorIntlProvider = {
  useClass: MatPaginatorEspIntl,
  provide: MatPaginatorIntl,
};
